import LoadingData from "components/Loading/LoadingData";
import TableStoreFinancialDocs from "../components/table-store-financial-docs";
import BignumbersTitulos from "../components/big-numbers-titulos";
import { Grid } from "@material-ui/core";

export default function TitulosFinanceirosView({
  showCardFinanceiro,
  cancelLoading,
  storeFinancial,
  pesquisandoTitulos,
  periodoTitulosLabel,
  storeRegistrationData,
  showCreditLimit,
  dadosBignumberFinanceiro,
  itemXSBigNumbersTitulos,
  handleStopSearching,
}) {
  return (
    <>
      {showCardFinanceiro &&
        !cancelLoading &&
        storeFinancial &&
        !pesquisandoTitulos && (
          <TableStoreFinancialDocs
            dataTable={storeFinancial}
            labelDias={periodoTitulosLabel}
            storePhone={storeRegistrationData?.FonePrincipal}
          />
        )}
      {showCreditLimit &&
        (storeFinancial || storeFinancial?.length === 0) &&
        showCardFinanceiro && (
          <Grid item xs={12}>
            <BignumbersTitulos
              data={dadosBignumberFinanceiro}
              isMobile={itemXSBigNumbersTitulos}
            />
          </Grid>
        )}

      {pesquisandoTitulos && (
        <Grid item xs={12}>
          <LoadingData
            searching={pesquisandoTitulos}
            onClick={() => handleStopSearching()}
            label="Buscando Títulos..."
          />
        </Grid>
      )}
    </>
  );
}
